import { useMutation, useQuery } from '@tanstack/react-query';
import { useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  getHraFormDocStatus,
  hraSignForm,
} from '../../../../pages/HRA/actions';
import { toast } from 'react-toastify';
import { getSessionInfo } from '../../../../helpers/functions';
import NoDocument from '../../../NoDocument';
import Button from '../../../Button';
import Spinner from '../../../Spinner';
import HRA_FORM_HTML from '..';
import NoValidDocument from '../../NoValidDocument';

const HRAFormSignMode = () => {
  const { docId = '' } = useParams();
  const formRef = useRef();
  const navigate = useNavigate();

  const { data = null, isLoading } = useQuery({
    queryFn: () =>
      getHraFormDocStatus({
        uuId: docId,
      }),
    queryKey: 'getHraFormDocStatus',
    onError: (error) => {
      const errMsg = error?.message ?? 'unexpected error';
      toast.error(errMsg);
    },
    enabled: Boolean(docId),
  });

  const { mutate, isLoading: isLoadingVerified } = useMutation({
    mutationFn: hraSignForm,
    mutationKey: 'hraSignForm',
    onSuccess: () => {
      toast.success('Document Saved.');
      navigate(`/hra-form-view-doc/${docId}`);
    },
    onError: (error) => {
      const errMsg = error?.message ?? 'unexpected error';
      toast.error(errMsg);
    },
  });

  const documentData = isLoading ? null : data?.data?.data;

  function handleSubmit() {
    const formValues = formRef.current?.getFormValues();
    const template = formRef.current?.getFormTemplate();

    if (!formValues?.SIGNATURE) {
      return toast.error('Please Sign the document.');
    }

    const payload = {
      uuId: docId,
      language: 'en',
      data: formValues,
      browserInfo: getSessionInfo(),
      htmlTemplate: template,
    };

    mutate(payload);
  }

  if (!docId) return <NoDocument />;

  if (documentData?.getHraFormData?.formDocumentStatus === 'SIGNED')
    navigate(`/hra-form-view-doc/${docId}`);

  if (isLoading) {
    return (
      <div className="d--flex align-items--center justify-content--center h--full w--full">
        <Spinner size="lg" />
      </div>
    );
  }
  if (!isLoading && !documentData?.getHraFormData) {
    return <NoValidDocument />;
  }

  return (
    <div className="d--flex h--full w--full ">
      <div className="d--flex gap--sm w--full">
        <div className="w--full h--full mx--auto box-shadow--xs overflow--auto p-b--4xl">
          <HRA_FORM_HTML documentData={documentData} ref={formRef} />
        </div>
        <div className="position--fixed left--0 bottom--0 h-min--50 gap--sm w--full bg--white d--flex align-items--center justify-content--center">
          <Button
            onClick={handleSubmit}
            variant="primary"
            color="black"
            isOutline
            borderColor="primary"
            btnClasses="btn w-max--150"
            data-link-hover
            size="sm"
            disabled={isLoadingVerified}
          >
            {isLoadingVerified ? 'Please wait...' : 'Submit'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default HRAFormSignMode;
